define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/dateUtils", "./logoutActions", "../../models/UserContext"], function (require, exports, $, ko, log, tools, DateUtils, LogoutActions, UserContext) {
    "use strict";
    var ReportBase = /** @class */ (function () {
        function ReportBase() {
            this.filterCdrSummaryReportByStartDate = ko.observable(DateUtils.today());
            this.filterCdrSummaryReportByEndDate = ko.observable(DateUtils.today());
            this.dateRangeText = ko.observable("Today");
            this.dateRangeType = ko.observable(0);
            this.selectRangeTimeout = 0;
            this.filterCdrByDomain = ko.observable("");
            this.domainAllAccounts = ko.observableArray();
            this.initialCounter = true;
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Reports.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
            this.localFilterExtensions = ko.observable("");
            this.localFilterGroups = ko.observable("");
            this.localFilterDepartments = ko.observable("");
            this.logout = new LogoutActions();
            this.axisDefaults = {
                crosshair: {
                    tooltip: {
                        font: '14px Roboto,sans-serif',
                        color: "#777"
                    }
                },
                labels: {
                    font: '14px Roboto,sans-serif',
                    color: "#777",
                    rotation: "auto",
                    step: 1,
                    dateFormats: {
                        minutes: "h:mm tt",
                        hours: "h:mm tt",
                        days: "M/d",
                        months: "MMM 'yy",
                        weeks: "M/d",
                        years: "yyyy"
                    }
                },
                line: {
                    color: "#ededed"
                },
                majorGridLines: {
                    color: "#ededed",
                    step: 2
                },
                majorTicks: {
                    color: "#ededed"
                },
                minorGridLines: {
                    color: "#ededed"
                },
                minorTicks: {
                    color: "#ededed"
                },
                title: {
                    font: '14px Roboto,sans-serif',
                    color: "#777"
                }
            };
            this.seriesDefaults = {
                overlay: {
                    gradient: "none"
                }
            };
            this.greenPalete = [
                "#66bb6a",
                "#5ba85f",
                "#519554",
                "#47824a",
                "#3d703f",
                "#335d35",
                "#284a2a",
                "#66bb6a",
                "#75c178",
                "#84c887",
                "#93cf96",
                "#a3d6a5",
                "#b2ddb4",
                "#c1e3c3",
                "#d1ead2",
                "#e0f1e1",
                "#eff8f0",
                "#9bd39e"
            ];
            this.orangePalete = [
                "#ffa726",
                "#e59622",
                "#cc851e",
                "#b2741a",
                "#ffa726",
                "#ffaf3b",
                "#ffb851",
                "#ffc167",
                "#ffca7c",
                "#ffd392",
                "#ffdba8",
                "#ffe4bd",
                "#ffedd3",
                "#fff6e9",
                "#ffc673",
                "#ffbc59"
            ];
            this.bluePalete = [
                "#43bef7",
                "#3cabde",
                "#3598c5",
                "#2e85ac",
                "#287294",
                "#43bef7",
                "#55c4f7",
                "#68cbf8",
                "#7bd1f9",
                "#8ed8fa",
                "#a1defb",
                "#b3e5fb",
                "#c6ebfc",
                "#d9f2fd",
                "#ecf8fe",
                "#8cd7fa",
                "#74cff9"
            ];
            this.redPalete = [
                "#ef5350",
                "#d74a48",
                "#bf4240",
                "#a73a38",
                "#ef5350",
                "#f06461",
                "#f27572",
                "#f38684",
                "#f59796",
                "#f7a9a7",
                "#f8bab9",
                "#fbdcdc",
                "#fdeded",
                "#f59896",
                "#f3817f",
                "#facbca"
            ];
        }
        ReportBase.prototype.initMain = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            $('body').addClass('body_loaded');
            $("#domainsList").kendoDropDownList({
                filter: "startswith",
                dataSource: {
                    data: self.domainList
                },
                change: function (e) {
                    var selectedDomain = e.sender.value();
                    if (window.sessionStorage) {
                        window.sessionStorage.setItem("domain", selectedDomain);
                    }
                    self.filterCdrByDomain(selectedDomain);
                }
            });
            if (window.sessionStorage) {
                var periodType = window.sessionStorage.getItem("periodType");
                if (periodType) {
                    self.period(parseInt(periodType));
                }
            }
            self.filterCdrSummaryReportByStartDate.subscribe(function () {
                self.applyFilter();
            });
            self.filterCdrSummaryReportByEndDate.subscribe(function () {
                self.applyFilter();
            });
            self.filterCdrByDomain.extend({ rateLimit: 200 }).subscribe(function () {
                self.onDomainChanged();
            });
            $("#dtFilterDateFrom").kendoDateTimePicker({
                value: new Date()
            });
            $("#dtFilterDateTo").kendoDateTimePicker({
                value: new Date()
            });
            $("#sidebar__toggle, .sidebar__close").click(function () {
                $(".wrapper").toggleClass("alt");
                setTimeout(function () {
                    $(window).trigger("resize");
                }, 300);
                return false;
            });
            tools.initMenuActions(".date-ranges li a", self);
            $(".js-select-all").on("click", function (event) {
                var checked = $(event.currentTarget).prop('checked');
                var selectContainer = $(event.currentTarget).closest(".panel").find(".panel-body");
                $("input[type='checkbox']", selectContainer).prop('checked', checked);
            });
            //load stored 
            if (window.sessionStorage) {
                var selectedDomain = window.sessionStorage.getItem("domain");
                if (selectedDomain) {
                    var domainInList = self.domainList.find(function (item) {
                        return item === selectedDomain;
                    });
                    if (domainInList) {
                        $("#domainsList").data("kendoDropDownList").value(selectedDomain);
                        self.filterCdrByDomain(selectedDomain);
                    }
                }
            }
        };
        ReportBase.prototype.zoomChart = function (chartId, container, title, resizeCallBack) {
            var self = this;
            $("#zoomChartDialog .modal-body").append($("#" + chartId));
            $("#zoomChartDialog .modal-title").text(title);
            $('#zoomChartDialog').on('hide.bs.modal', function (e) {
                $("#" + container).append($("#" + chartId));
                setTimeout(function () {
                    resizeCallBack();
                    $('#zoomChartDialog').off('hide.bs.modal');
                    $('#zoomChartDialog').off('shown.bs.modal');
                });
            });
            $('#zoomChartDialog').on('shown.bs.modal', function (e) {
                resizeCallBack();
            });
            $("#zoomChartDialog").modal("show");
            resizeCallBack();
        };
        ReportBase.prototype.onDomainChanged = function () {
            var self = this;
            self.getDomainAllAccounts(self.filterCdrByDomain());
            self.applyFilter();
        };
        ReportBase.prototype.getDomainAllAccounts = function (domain) {
            var self = this;
            tools.ajaxPost({
                url: "/Reports/GetDomainAccountsData",
                data: { domain: domain },
                success: function (data) {
                    if (data.Data) {
                        self.domainAllAccounts(data.Data);
                    }
                }
            });
        };
        ReportBase.prototype.getExtensionName = function (extension) {
            var self = this;
            var ext = ko.utils.arrayFirst(self.domainAllAccounts(), function (item) {
                return item.Extension === extension;
            });
            if (ext) {
                return ext.OnlyName;
            }
            return "";
        };
        ReportBase.prototype.period = function (periodType) {
            var self = this;
            log.log(periodType);
            if (periodType === 0) { //today
                self.filterCdrSummaryReportByStartDate(DateUtils.today());
                self.filterCdrSummaryReportByEndDate(DateUtils.today());
                self.dateRangeText("Today");
            }
            else if (periodType === 1) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -1));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Yesterday");
            }
            else if (periodType === 2) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfWeek(DateUtils.today()));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfWeek(DateUtils.today()));
                self.dateRangeText("This Week");
            }
            else if (periodType === 3) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfWeek(DateUtils.addDays(DateUtils.today(), -7)));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfWeek(DateUtils.addDays(DateUtils.today(), -7)));
                self.dateRangeText("Last Week");
            }
            else if (periodType === 4) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfMonth(DateUtils.today()));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfMonth(DateUtils.today()));
                self.dateRangeText("This Month");
            }
            else if (periodType === 5) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfMonth(DateUtils.addMonths(DateUtils.today(), -1)));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfMonth(DateUtils.addMonths(DateUtils.today(), -1)));
                self.dateRangeText("Last Month");
            }
            else if (periodType === 6) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -60));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Last 60 days");
            }
            else if (periodType === 7) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -180));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Last 180 days");
            }
            else if (periodType === 99) {
                self.openDateFilterDialog();
            }
            if (periodType !== 99) {
                self.dateRangeType(periodType);
                if (window.sessionStorage) {
                    window.sessionStorage.setItem("periodType", periodType);
                }
            }
        };
        ReportBase.prototype.openDateFilterDialog = function () {
            var self = this;
            var dateFrom = $("#dtFilterDateFrom").data("kendoDateTimePicker");
            var dateTo = $("#dtFilterDateTo").data("kendoDateTimePicker");
            dateFrom.value(self.filterCdrSummaryReportByStartDate());
            dateTo.value(self.filterCdrSummaryReportByEndDate());
            $("#filterDateDialog").modal("show");
        };
        ReportBase.prototype.filterDateClicked = function () {
            var self = this;
            var dateFrom = $("#dtFilterDateFrom").data("kendoDateTimePicker");
            var dateTo = $("#dtFilterDateTo").data("kendoDateTimePicker");
            self.dateRangeType(99);
            self.filterCdrSummaryReportByStartDate(dateFrom.value());
            self.filterCdrSummaryReportByEndDate(dateTo.value());
            $("#filterDateDialog").modal("hide");
            self.updateRangeText();
            self.applyFilter();
        };
        ReportBase.prototype.updateRangeText = function () {
            var self = this;
            var today = DateUtils.today();
            var start = self.filterCdrSummaryReportByStartDate();
            var end = self.filterCdrSummaryReportByEndDate();
            //check if the same date
            if (start.getFullYear() === end.getFullYear() &&
                start.getMonth() === end.getMonth() &&
                start.getDate() === end.getDate()) {
                if (start.getFullYear() === today.getFullYear()) {
                    self.dateRangeText(kendo.toString(start, "m"));
                }
                else {
                    self.dateRangeText(kendo.toString(start, "d"));
                }
            }
            else {
                if (start.getFullYear() === today.getFullYear()) {
                    self.dateRangeText(kendo.toString(start, "m") + " - " + kendo.toString(end, "m"));
                }
                else {
                    self.dateRangeText(kendo.toString(start, "d") + " - " + kendo.toString(end, "d"));
                }
            }
        };
        ReportBase.prototype.applyFilter = function () {
        };
        ReportBase.prototype.runCountTo = function () {
            var self = this;
            if (!self.initialCounter) {
                $(".count-to").countTo("destroy");
                $(".count-to-formated").countTo("destroy");
            }
            self.initialCounter = false;
            var countTo = $(".count-to");
            if (countTo.length) {
                countTo.countTo({
                    refreshInterval: 20,
                    formatter: function (value, options) {
                        return kendo.toString(value, "N0");
                    }
                });
            }
            var countToFormated = $(".count-to-formated");
            if (countToFormated.length) {
                countToFormated.countTo({
                    refreshInterval: 20,
                    formatter: function (value, options) {
                        return DateUtils.secondsToDuration(value);
                    }
                });
            }
        };
        ReportBase.prototype.clearFilter = function () {
            var self = this;
            self.filterCdrSummaryReportByStartDate(DateUtils.today());
            self.filterCdrSummaryReportByEndDate(DateUtils.today());
            self.filterCdrByDomain(self.domainList[0]);
        };
        ReportBase.prototype.print = function () {
            window.print();
        };
        ReportBase.prototype.getRandomColor = function () {
            var self = this;
            var paletes = [
                self.greenPalete,
                self.orangePalete,
                self.bluePalete,
                self.redPalete
            ];
            var palete = paletes[Math.floor(Math.random() * 4)];
            return palete[Math.floor(Math.random() * palete.length - 1)];
        };
        return ReportBase;
    }());
    return ReportBase;
});
//# sourceMappingURL=reportBase.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/reportBase.js
// module id = 20
// module chunks = 2